// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================Dependances===================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';

// ==================components===================
import Markers from '../../Site/MapLeaflet/Markers';

// ==================Actions===================
import { setNetworkMarker, setSaveNetworkMarkerComponent } from '../../../actions/network';

function MapNetwork() {
  // ============HOOKS================
  const dispatch = useDispatch();
  const loadingMap = useSelector((state) => state.site.map.loadingMap);
  const mapURL = useSelector((state) => state.site.map.mapURL);
  const center = useSelector((state) => state.site.map.center);
  const networkArray = useSelector((state) => state.network.networkArray);
  const networkComponent = useSelector((state) => state.network.networkComponent);
  const networkMarker = useSelector((state) => state.network.networkMarker);
  let markerComponents = [];

  // ==================UseEffect=============
  // when network array change launch update of marker to display with new list information
  useEffect(() => {
    if (networkArray.length !== 0) {
      markerComponents = networkArray.map((marker) => (
        <Markers
          key={marker.marker_long_name}
          shortName={marker.marker}
          longName={marker.marker_long_name}
          lon={marker.location.coordinates.lon}
          lat={marker.location.coordinates.lat}
          alt={marker.location.coordinates.altitude}
          installDate={marker.date_from}
          endDate={marker.date_to}
          country={marker.location.country.name}
          network={marker.network.name}
        />
      ));
      dispatch(setSaveNetworkMarkerComponent(markerComponents));
    }
  }, [networkArray]);

  useEffect(() => {
    if (networkComponent.length !== 0) {
      dispatch(setNetworkMarker(true));
    }
  }, [networkComponent]);
  return (
    <MapContainer
      center={center}
      zoom={4}
      minZoom={2}
      style={{ width: 'auto', height: '100%' }}
    >
      <TileLayer url={mapURL} />
      {(loadingMap === false && networkMarker === true)
      && networkComponent}
    </MapContainer>
  );
}

export default MapNetwork;
